import React from "react";
import LegalDocs from "@/pages/LegalDocs";
export default function Agreements() { return <LegalDocs docClass="agreement" />; }
